// extracted by mini-css-extract-plugin
export default {"buttonAdd":"ButtonAddToCard_buttonAdd__7F9MD","added":"ButtonAddToCard_added__QxwF8"};